interface LetterLinkProps {
  letter: string
  isAvailable: boolean
  size: 'sm' | 'xs'
  ariaLabelPrefix: string
}

export function LetterLink({letter, isAvailable, size, ariaLabelPrefix}: LetterLinkProps) {
  const sizeClasses = size === 'sm' ? 'text-sm h-8 w-8' : 'text-xs h-7 w-7'

  if (!isAvailable) {
    return (
      <span className={`${sizeClasses} flex items-center justify-center font-medium text-b8b6b4`} aria-disabled="true">
        {letter}
      </span>
    )
  }

  return (
    <a
      href={`#letter-${letter}`}
      className={`${sizeClasses} flex items-center justify-center rounded-full font-medium text-2a2928 transition-colors hover:bg-[#f5f4f2] hover:text-5a7269`}
      aria-label={`${ariaLabelPrefix} ${letter}`}
    >
      {letter}
    </a>
  )
}
